var mp = mp || {};

// Slider - Hero
//-----------------------------------------------------------------
mp.sliderHero = function() {
    var $slider = $('.hero__slider .slider');

    if (!$slider.length) {
        return;
    }

    $slider.on('init', function(slick) {
        $(this).find(".slick-active").addClass("slick-animate");
    });

    $sliderHero = $slider.slick({
        arrows: false,
        dots: false,
        speed: 1800, 
        fade: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 6000,
        rows: 0
    });

    $sliderHero.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $currentSlide = $(this).find(".slick-slide").eq(currentSlide);
        $nextSlide = $(this).find(".slick-slide").eq(nextSlide);
        

        // Animate slides
        window.setTimeout(function() {
            $currentSlide.removeClass("slick-animate");
        }, 1800);

        $nextSlide.addClass("slick-animate");
    });
}

// Slider - Testimonilas
//-----------------------------------------------------------------
mp.sliderTestimonilas = function() {
    var $slider = $('.testimonials__slider .slider');

    if (!$slider.length) {
        return;
    }

    $slick = $slider.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: false,
        dots: true,
        speed: 800,
        fade: false,
        pauseOnFocus: false,
        pauseOnHover: true,
        infinite: true,
        prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
    });
}


// Slider - Testimonilas
//-----------------------------------------------------------------
mp.sliderClients = function() {
    var $slider = $('.clients__slider .slider');

    if (!$slider.length) {
        return;
    }

    $slider.slick({
        autoplay: true,
        autoplaySpeed: 1000,
        arrows: false,
        dots: false,
        speed: 800,
        fade: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        infinite: true,
        rows: 0,
        //centerMode: true,
        variableWidth: true,
        initialSlide: 4
    });
}


// Slider - ProductGallery
//-----------------------------------------------------------------
mp.slidertGallery = function() {
    var $slider = $('.card-02 .slider');

    if (!$slider.length) {
        return;
    }

    $slick = $slider.slick({
        autoplay: true,
        autoplaySpeed: 5000,
        arrows: true,
        dots: false,
        speed: 800,
        fade: false,
        pauseOnFocus: false,
        pauseOnHover: true,
        infinite: true,
        rows: 0,
        prevArrow: '<button type="button" class="slick-prev slick-arrow"></button>',
        nextArrow: '<button type="button" class="slick-next slick-arrow"></button>',
    });
}





$(document).ready(function (){
    mp.sliderHero();
    mp.sliderTestimonilas();
    mp.sliderClients();
    mp.slidertGallery();
});